<template>
  <div class="page-container">
    <div style="width: 900px; margin: 0 auto">
      <div style="text-align: center; margin-bottom: 50px; padding-top: 100px">
        <span style="font-size: 25px">{{$t('changeAccount.changeAccount26')}}</span>
      </div>
      <el-steps :active="active" finish-status="success">
        <el-step :title="$t('login.login23')"></el-step>
        <el-step :title="$t('login.login6')"></el-step>
        <el-step :title="$t('loginR.login25')"></el-step>
      </el-steps>
      <div class="block">
        <el-carousel
          style="margin-top: 100px"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          :loop="false"
          ref="carousel"
        >
          <el-carousel-item name="check">
            <div>
              <div style=" margin-left: 270px">
                <span style="font-size: 16px">
                  {{$t('changeAccount.changeAccount3')}}：{{ showEmail }}
                </span>
              </div>
              <div>
                <el-input
                  :placeholder="$t('changeAccount.changeAccount13')"
                  auto-complete="new-accounts"
                  v-model="verifyCode"
                  style="width: 260px; margin-left: 270px; margin-top: 25px"
                  @blur="checkVerityCode"
                  @focus="clearTip"
                >
                </el-input>
                <el-button
                  style="width: 154px; height: 50px"
                  type="info"
                  @click="sendCode"
                  :disabled="disabled"
                  >{{ sendBtnText }}</el-button
                >
                <div
                  style="display: flex;justify-content: center;"
                  v-if="tipActive"
                >
                  <img
                    src="../../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="!res"
                  />
                  <img
                    src="../../assets/images/setting/p0.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="res"
                  />
                  <span style="color: red; font-size: 15px" v-if="!res">{{
                    tip
                  }}</span>
                  <span style="color: green; font-size: 15px" v-if="res">{{
                    tip
                  }}</span>
                </div>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('loginR.login26')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="set">
            <div>
              <div>
                <el-input
                  type="password"
                  :placeholder="$t('login.login9')"
                  v-model="password"
                  auto-complete="new-password"
                  style="width: 397px; margin-left: 300px"
                  @blur="checkPassword(0)"
                  @focus="clearTip"
                >
                </el-input>
                <div
                  style="display: flex;justify-content: center;"
                  v-if="tipActive"
                >
                  <img
                    src="../../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                  />
                  <span style="color: red; font-size: 15px">{{ tip }}</span>
                </div>
              </div>
              <div>
                <el-input
                  type="password"
                  :placeholder="$t('login.login10')"
                  auto-complete="new-password"
                  v-model="rePassword"
                  style="width: 397px; margin-left: 300px; margin-top: 25px"
                  @blur="checkPassword(1)"
                  @focus="clearTip"
                >
                </el-input>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 397px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('loginR.login26')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="complete">
            <div style="text-align: center">
              <img src="../../assets/images/setting/u534.png" alt="" />
            </div>
            <div style="text-align: center; margin-top: 15px">
              <span style="font-size: 20px"
                >{{$t('changeAccount.changeAccount52')}}</span
              >
            </div>
            <div style="text-align: center; margin-top: 10px">
              <span style="font-size: 16px"
                >{{$t('changeAccount.changeAccount53')}}，{{$t('changeAccount.changeAccount54')}}{{ timeCount }}{{$t('changeAccount.changeAccount55')}}</span
              >
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px;
                margin-top: 25px;
              "
              >{{$t('loginR.login30')}}</el-button
            >
          </el-carousel-item>
        </el-carousel>
        <div style="background-color: rgba(249, 249, 249, 1); padding: 20px">
          <div style="margin-bottom: 10px">
            <span style="color: #999999; font-size: 16px">{{$t('changeAccount.changeAccount40')}}</span>
          </div>
          <div style="margin-bottom: 5px">
            <span style="color: #999999"
              >• {{$t('changeAccount.changeAccount41')}}</span
            >
          </div>
          <div>
            <span style="color: #999999"
              >• {{$t('changeAccount.changeAccount42')}}400-1688-168（9:00-22:00）</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.el-input__inner {
  height: 50px;
  font-size: 16px;
}
</style>
<script>
export default {
  data() {
    return {
      showEmail: "",
      password: "",
      rePassword: "",
      res: false,
      sendBtnText: this.$t('changeAccount.changeAccount14'),
      timeCount: 0,
      verifyCode: "",
      tip: "",
      tipActive: false,
      active: 0,
      disabled: false,
      timer: null,
      secretCode: "",
    };
  },
  methods: {
    checkPassword(type) {
      if (type == 0) {
        if (!this.password || !this.password.trim(" ")) {
          this.tip = this.$t('login.login11');
          this.tipActive = true;
        } else {
          var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,16}$/; //6-16位数字大小写字母组合
          if (reg.test(this.password)) {
          } else {
            this.tip = this.$t('changeAccount.changeAccount51');
            this.tipActive = true;
          }
        }
      } else if (type == 1) {
        if (!this.rePassword || !this.rePassword.trim(" ")) {
          this.tip = this.$t('login.login14');
          this.tipActive = true;
        } else {
          if (this.password != this.rePassword) {
            this.tip = this.$t('login.login15');
            this.tipActive = true;
          }
        }
      }
    },
    startTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.disabled = true;
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
            this.sendBtnText = this.timeCount + this.$t('changeAccount.changeAccount36')+ this.$t('changeAccount.changeAccount37');
          } else {
            this.disabled = false;
            this.sendBtnText = this.$t('loginR.login31');
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    checkVerityCode() {
      if (!this.verifyCode || !this.verifyCode.trim(" ")) {
        this.res = false;
        this.tip = this.$t('login.login16');
        this.tipActive = true;
      } else {
        const regMobile = /^[0-9]{4}$/;
        if (!regMobile.test(this.verifyCode)) {
          this.res = false;
          this.tip = this.$t('login.login17');
          this.tipActive = true;
        }
      }
    },
    async sendCode() {
      if (!this.disabled) {
        var url = "admin/sendVerificationCode";
        const { data: res } = await this.$http.get(url, {
          params: { smsType: 1 },
        });
        if (res.code == 200) {
          this.res = true;
          this.tip = this.$t('login.login18');
          this.tipActive = true;
          this.startTimer();
        } else {
          this.res = false;
          this.tip = res.message;
          this.tipActive = true;
        }
      }
    },
    clearTip() {
      (this.tip = ""), (this.tipActive = false);
    },
    async next() {
      if (this.active == 0) {
        this.clearTip();
        this.checkVerityCode();
        if (!this.tipActive) {
          var url = "admin/verifyCode";
          const { data: res } = await this.$http.post(url, {
            code: this.verifyCode,
          });
          if (res.code == 200) {
            this.res = false;
            this.secretCode = res.data.secretCode;
            this.tipActive = false;
            this.tip = "";
            this.active = 1;
            this.$refs.carousel.next();
          } else {
            this.res = false;
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 1) {
        this.checkPassword(0);
        this.checkPassword(1);
        if (!this.tipActive) {
          var url = "admin/modifyAccountBinding";
          const { data: res } = await this.$http.post(url, {
            password: this.password,
            confirmPassword: this.rePassword,
            secretCode: this.secretCode,
          });
          if (res.code == 200) {
            clearInterval(this.timer);
            this.timer = null;
            this.tipActive = false;
            this.tip = "";
            this.active = 3;
            this.$refs.carousel.next();
            const TIME_COUNT2 = 3;
            if (!this.timer) {
              this.timeCount = TIME_COUNT2;
              this.timer = setInterval(() => {
                if (this.timeCount > 0 && this.timeCount <= TIME_COUNT2) {
                  this.timeCount--;
                } else {
                  clearInterval(this.timer);
                  this.timer = null;
                  window.sessionStorage.removeItem("token");
                  this.$router.push({
                    name:'login'
                  });
                }
              }, 1000);
            }
          } else {
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 3) {
        window.sessionStorage.removeItem("token");
        this.$router.push({
          name:'login'
        });
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      if (res.code == 200) {
        this.showEmail =res.data.emailAddress.substring(0, 3) +
                "****" +
                res.data.emailAddress.substring(res.data.emailAddress.indexOf("@"));
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>
